/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Medialibrarytoolevent3Inputs */

const en_medialibrarytoolevent3 = /** @type {(inputs: Medialibrarytoolevent3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event`)
};

const de_medialibrarytoolevent3 = /** @type {(inputs: Medialibrarytoolevent3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstaltung`)
};

/**
* | output |
* | --- |
* | "Event" |
*
* @param {Medialibrarytoolevent3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const medialibrarytoolevent3 = /** @type {((inputs?: Medialibrarytoolevent3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Medialibrarytoolevent3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_medialibrarytoolevent3(inputs)
	return de_medialibrarytoolevent3(inputs)
});
export { medialibrarytoolevent3 as "mediaLibraryToolEvent" }